import { MenuItem } from '../../../types';
import {
  DashboardMenuItem,
  MyRequestsMenuItem,
  ApprovalsMenuItem,
  ReportsMenuItem,
  ProcurementsItem,
} from '../shares';

export const ESSItems: MenuItem[] = [
  DashboardMenuItem,
  MyRequestsMenuItem,
  ApprovalsMenuItem,
  ReportsMenuItem,
];

export const MRItems: MenuItem[] = [
  DashboardMenuItem,
  MyRequestsMenuItem,
  ApprovalsMenuItem,
  ReportsMenuItem,
  ProcurementsItem,
];
